import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, Trash2, Archive } from 'lucide-react';
import { Button } from '../ui/Button';
interface StreamSettingsPanelProps {
  isOpen: boolean;
  onClose: () => void;
  streamName: string;
}
export function StreamSettingsPanel({
  isOpen,
  onClose,
  streamName
}: StreamSettingsPanelProps) {
  const [activeTab, setActiveTab] = useState('general');
  if (!isOpen) return null;
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <motion.div initial={{
      scale: 0.95,
      y: 20
    }} animate={{
      scale: 1,
      y: 0
    }} className="w-full max-w-2xl bg-surface-900 border border-surface-600 rounded-xl shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-surface-600 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-text-primary">Stream Settings</h2>
          <button onClick={onClose} className="text-text-muted hover:text-text-primary">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="border-b border-surface-600 px-6">
          <div className="flex gap-6">
            {['general', 'sharing', 'agents', 'danger'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`py-4 text-sm font-medium border-b-2 transition-colors capitalize ${activeTab === tab ? 'border-primary-500 text-primary-400' : 'border-transparent text-text-secondary hover:text-text-primary'}`}>
                {tab === 'danger' ? 'Danger Zone' : tab}
              </button>)}
          </div>
        </div>

        <div className="p-6 h-[400px] overflow-y-auto">
          {activeTab === 'general' && <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Stream Name
                </label>
                <input type="text" defaultValue={streamName} className="w-full bg-surface-800 border border-surface-500 rounded-lg px-4 py-2 text-text-primary" />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Description
                </label>
                <textarea className="w-full bg-surface-800 border border-surface-500 rounded-lg px-4 py-2 text-text-primary h-24 resize-none" />
              </div>
            </div>}

          {activeTab === 'danger' && <div className="space-y-6">
              <div className="border border-danger-900/50 bg-danger-900/10 rounded-xl p-6">
                <h3 className="text-danger-400 font-medium mb-2">
                  Archive Stream
                </h3>
                <p className="text-sm text-danger-200/70 mb-4">
                  Stream will be hidden but not deleted. You can restore it
                  later.
                </p>
                <Button variant="secondary" className="border-danger-900/50 text-danger-400 hover:bg-danger-900/20">
                  <Archive className="w-4 h-4 mr-2" />
                  Archive Stream
                </Button>
              </div>

              <div className="border border-danger-900/50 bg-danger-900/10 rounded-xl p-6">
                <h3 className="text-danger-400 font-medium mb-2">Delete Stream</h3>
                <p className="text-sm text-danger-200/70 mb-4">
                  This action cannot be undone. All tasks and history will be
                  lost.
                </p>
                <Button className="bg-danger-600 hover:bg-danger-700 text-text-primary border-none">
                  <Trash2 className="w-4 h-4 mr-2" />
                  Delete Stream
                </Button>
              </div>
            </div>}
        </div>

        <div className="p-6 border-t border-surface-600 bg-surface-900/50 flex justify-end gap-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button className="bg-primary-600 hover:bg-blue-700 text-text-primary border-none">
            Save Changes
          </Button>
        </div>
      </motion.div>
    </motion.div>;
}